/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceAction,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the Folio HTTP resource (factory product). */
export class FolioResource {
}

export function createFolioResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const Folio = createAdnHttpResource(send, 'folios', () => localUserProfile);
  Folio.copy = createAdnHttpResourceAction(send, {
    method: 'POST',
    url: ApiConfig.obtain().getVersionedUri('folios') + '/:id/copy',
    queryParams: ['folioId', 'name', 'copyLineItems', 'copyTargeting', 'copyCreatives', 'creativeSetUserState']
  });

  Folio.copyFolio = function(folio: any, newId: any, lineItemUserState: any, copyLineItems: any, copyTargeting: any, copyCreatives: any) {
    if (!folio || !folio.id) {
      return Promise.reject('Insufficient parameters for the folio copy');
    }
    return Folio.copy({
      id: folio.id,
      folioId: newId || '',
      name: folio.name,
      copyTargeting: _.isBoolean(copyTargeting) ? copyTargeting : true,
      copyCreatives: _.isBoolean(copyCreatives) ? copyCreatives : true,
      copyLineItems: _.isBoolean(copyLineItems) ? copyLineItems : true,
      creativeSetUserState: lineItemUserState || ''
    });
  };

  return Folio;
}

export const folioResourceProvider = {
  provide: FolioResource,
  useFactory: createFolioResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

